export default __webpack_public_path__ + "static/media/avatar.2604e426.svg";